import { ref, onMounted, onUnmounted } from 'vue'

export function useWindowResize() {
  const windowWidth = ref(0)
  const windowHeight = ref(0)
  const isMobile = ref(false)
  const isTablet = ref(false)
  const isDesktop = ref(false)

  // 更新窗口尺寸
  const updateWindowSize = () => {
    if (process.client) {
      windowWidth.value = window.innerWidth
      windowHeight.value = window.innerHeight
      
      // 根据屏幕宽度判断设备类型
      isMobile.value = windowWidth.value < 768
      isTablet.value = windowWidth.value >= 768 && windowWidth.value < 1024
      isDesktop.value = windowWidth.value >= 1024
    }
  }

  // 防抖函数
  const debounce = (func, wait) => {
    let timeout
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout)
        func(...args)
      }
      clearTimeout(timeout)
      timeout = setTimeout(later, wait)
    }
  }

  // 防抖的更新函数
  const debouncedUpdate = debounce(updateWindowSize, 100)

  onMounted(() => {
    if (process.client) {
      // 初始化尺寸
      updateWindowSize()
      
      // 监听窗口大小变化
      window.addEventListener('resize', debouncedUpdate)
    }
  })

  onUnmounted(() => {
    if (process.client) {
      window.removeEventListener('resize', debouncedUpdate)
    }
  })

  return {
    windowWidth,
    windowHeight,
    isMobile,
    isTablet,
    isDesktop,
    updateWindowSize
  }
}
